/* eslint-disable react/no-danger */
import { useLocation } from 'react-router-dom';

import { GoBackButton } from '~/components';
import { IExercise } from '~/models/Exercise';

import * as S from './styles';

type ShowVideoParams = {
  videoData: IExercise;
};

const ShowExerciseVideo = () => {
  const { state } = useLocation<ShowVideoParams>();

  const extractVideoId = (url = ''): [string, string] | null => {
    // Regex para YouTube e Vimeo
    const youtubePattern = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?/]+)/;
    const vimeoPattern = /vimeo\.com\/(?:video\/)?(\d+)/;

    // Testa se é uma URL do YouTube
    const youtubeMatch = url.match(youtubePattern);
    if (youtubeMatch) {
      return ['youtube', youtubeMatch[1]];
    }

    // Testa se é uma URL do Vimeo
    const vimeoMatch = url.match(vimeoPattern);
    if (vimeoMatch) {
      return ['vimeo', vimeoMatch[1]];
    }

    return null;
  };

  const renderIframe = () => {
    const videoInfo = extractVideoId(state.videoData.video_url);

    if (!videoInfo) {
      return <p style={{ color: '#fff' }}>URL não reconhecida ou suportada.</p>;
    }

    const [platform, id] = videoInfo;
    const src =
      platform === 'youtube'
        ? `https://www.youtube.com/embed/${id}`
        : `https://player.vimeo.com/video/${id}`;

    console.log('src:', src);

    return (
      <iframe
        title={state.videoData?.name}
        width="660"
        height="470"
        src={src}
        frameBorder="0"
        allowFullScreen
      />
    );
  };

  return (
    <>
      <GoBackButton
        containerStyle={{ alignSelf: 'flex-start', paddingTop: '2.2rem' }}
      />
      <S.Container>
        {renderIframe()}

        <S.VideoData>
          <S.Segment>{state?.videoData?.muscle_segment}</S.Segment>
          <S.Title>{state?.videoData?.name}</S.Title>
          <S.Divider />
          <S.Description>{state?.videoData?.video_description}</S.Description>
        </S.VideoData>
      </S.Container>
    </>
  );
};

export default ShowExerciseVideo;
